import { SelectLanguage } from "components/base/SelectLanguage";

import StyledHeaderLanguage from "./index.style";

const HeaderLanguage = () => {
  return (
    <StyledHeaderLanguage>
      <div style={{ margin: "unset" }} className="lang">
        <div className="lang__text">My Country is</div>

        <SelectLanguage />
      </div>
    </StyledHeaderLanguage>
  );
};

export default HeaderLanguage;
